import { Component, Input } from '@angular/core';
import { RenalDetectRecommendationDetails } from '@app/core/models';
import { RenalDetectStatusEnum } from '@app/shared/utils';
import { getRenalDetectRecoDetailsByStatus } from '@app/shared/utils/static-helpers/prediction-helper';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-renal-graph',
  templateUrl: './renal-graph.component.html',
  styleUrls: ['./renal-graph.component.scss'],
  imports: [NgStyle],
})
export class RenalGraphComponent {
  RenalDetectStatus = RenalDetectStatusEnum;

  // Gauge value
  height = 10;
  fullWidth = 260;
  centeredPosition = this.height / 2;
  rectSize = this.fullWidth / 3;

  private _status: RenalDetectStatusEnum;

  renalDetectRecommendationDetails: RenalDetectRecommendationDetails;

  @Input() set status(value: RenalDetectStatusEnum) {
    this._status = value;
    this.renalDetectRecommendationDetails = getRenalDetectRecoDetailsByStatus(this.status);
  }
  get status(): RenalDetectStatusEnum {
    return this._status;
  }
}
